import { CommonModule } from "@angular/common";
import { Component, Input, OnDestroy, inject } from "@angular/core";
import { CONSTANTS } from "@constants";
import { GlobalVarsModel } from "@models/ModelGlobalsVar";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { BaseService } from "@providers/BaseService";
import { Subject, Subscription, takeUntil, timer } from "rxjs";

@Component({
  selector: "lb-visitors",
  templateUrl: "./lobby-visitors.html",
  standalone: true,
  styleUrls: ["./lobby-visitors.scss"],
  imports: [CommonModule, TranslateModule],
})
export class LobbyVisitors extends BaseService implements OnDestroy {
  @Input() visitorsNumber: number;
  @Input() isNewLocation: boolean = false;
  declare globalVars: GlobalVarsModel;
  lobbyConstants = CONSTANTS;
  translate = inject(TranslateService);
  open = true;
  private timerSubscription: Subscription;
  destroy$: Subject<void> = new Subject<void>();

  constructor() {
    super();
    this.newBaseService.getVars.pipe(takeUntil(this.destroy$)).subscribe((data: GlobalVarsModel) => {
      this.globalVars = data;
    });

    this.timerSubscription = timer(0, 2000).subscribe(() => {
      const currentNumber = this.visitorsNumber;
      const change = Math.random() < 0.5 ? -1 : 1;
      this.visitorsNumber = currentNumber + change;
    });
  }

  ngOnDestroy() {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
    this.destroy$.next();
    this.destroy$.complete();
  }
}
